import React from 'react';  
import {Button,Col,Row,Input,FormGroup,Label} from "reactstrap";
import { makeStyles } from '@material-ui/core/styles';  
import Paper from '@material-ui/core/Paper';  
import Table from '@material-ui/core/Table';  
import TableBody from '@material-ui/core/TableBody';  
import TableCell from '@material-ui/core/TableCell';  
import TableContainer from '@material-ui/core/TableContainer';  
import TableHead from '@material-ui/core/TableHead';  
import TablePagination from '@material-ui/core/TablePagination';  
import TableRow from '@material-ui/core/TableRow';
import FormControlLabel from '@material-ui/core/FormControlLabel';  
import Switch from '@material-ui/core/Switch';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import AssignmentIcon from '@material-ui/icons/Assignment';
//import { green, pink } from '@material-ui/core/colors';
import axios from 'axios';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import '../../css/Grid.css'; 
import { useState, useEffect } from 'react'   
import ModListino from './ModListino';
import {GetMessage} from "../../Modules/Message";
import {GetTextZona,GetToken,GetRole,GetTitServizi} from "../../Modules/Funzioni";
import MyAlert from '../MyAlert';
import imgSearch from "../../img/search.png";
import Avatar from '@material-ui/core/Avatar';
import {Ruolo_Admin } from '../../Modules/Costanti';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '98%',
    },
    paper: {
        width: '98%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    /*pink: {
        color: theme.palette.getContrastText(pink[500]),
        backgroundColor: pink[500],
      },*/
      BtnEdit: {
        color: '#fff',
        backgroundColor:"rgba(18, 35, 95, 0.84) !important",
        '&:hover':{
            cursor:"pointer"
      }  
    }
}));
  
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'Mod', string: false, disablePadding: true, label: '' },
    { id: 'Titolo', string: false, disablePadding: true, label: 'Titolo' },
    { id: 'Descrizione', string: false, disablePadding: true, label: 'Descrizione' },
    { id: 'Rischio', string: false, disablePadding: true, label: 'Rischio' },
    { id: 'Zona', string: false, disablePadding: true, label: 'Zona' },
    { id: 'Prezzo', string: false, disablePadding: true, label: 'Imponibile' },
    
];


function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell className="grid-head"
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};
export default function MatPaginationTable() {  
  const classes = useStyles();  
  const [order, setOrder] = React.useState('asc');

  const [RicDescrizione, setRicDescrizione] = React.useState("");
  const [RicRischio, setRicRischio] = React.useState("");
  const [RicTitolo, setRicTitolo] = React.useState("");
  const [RicZona, setRicZona] = React.useState("");
  const [orderBy, setOrderBy] = React.useState('Titolo');
  const [page, setPage] = React.useState(0);  
  const [data, setData] = useState([]); 
  const [isLoading, setIsLoading] = useState(true);
  const [DisableFilter, setDisableFilter] = useState(true);
  const [isSending, setIsSending] = useState(false);   
  const [rowsPerPage, setRowsPerPage] = React.useState(50);  
  const [dense, setDense] = React.useState(false);
  const [isOpenModListino, setIsOpenModListino] = useState(false);
  const [IdModListino, setIdModListino] = useState("");
  //alert object
  const [OpenAlert, setOpenAlert] = React.useState(false);
  const [MsgAlert,setMsgAlert]=React.useState("");
  let UserRole =GetRole(localStorage.getItem("token"));
  const onCloseAlert = (event) => {
    setOpenAlert(false);
};
  const toggleModListino = (mId) => {
    setIsOpenModListino(!isOpenModListino);
    if (!isOpenModListino){
        setIdModListino(mId);
    }
  }

  useEffect(() => {    
        setIsLoading(true);
        const token = GetToken(localStorage.getItem("token"));
        const ax= axios;
        ax.defaults.headers.common['Authorization']="Bearer " + token;
        
        (async () => {
            let result=[];
            try{
                let url=process.env.REACT_APP_API_URL+'listinolist'
                const axiosConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                const fd = new FormData();
                fd.append("Descrizione", RicDescrizione);
                fd.append("Rischio", RicRischio);
                fd.append("Titolo", RicTitolo);
                fd.append("Zona", RicZona);

                //idazienda/0/codfiscale/0/cognome/0
                result = await ax.post(url,fd,axiosConfig);
            }
            catch(error) {
                let msg=""
                if (error.response!==undefined) {
                    msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                }
                else
                {
                    msg=GetMessage(undefined,"");
                }
                setMsgAlert(msg);
                setOpenAlert(true);

            }
            setIsLoading(false);    
            if (result.data!==undefined)    {
                setData(result.data);
            }
            else {
                setData([]);
            }
        })(); 
        
}, [isSending]);   


  const handleChangePage = (event, newPage) => {  
    setPage(newPage);  
  };  
 
  const handleChangeRowsPerPage = event => {  
    setRowsPerPage(+event.target.value);  
    setPage(0);  
  };  
  
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
};

const onLoadData = () => {
    setIsSending(!isSending);
}; 

const onFilter = () => {
    setDisableFilter(true);
    setIsSending(!isSending);
    setPage(0);
}; 
const handleRicDescrizione = (event) => {
    setRicDescrizione(event.target.value);
    setDisableFilter(false);
};

const handleRicRischio = (event) => {
    setRicRischio(event.target.value);
    setDisableFilter(false);
};

const handleRicTitolo = (event) => {
    setRicTitolo(event.target.value);
    setDisableFilter(false);
};

const handleRicZona = (event) => {
    setRicZona(event.target.value);
    setDisableFilter(false);
};

const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
};
let emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
if (emptyRows>5){emptyRows=3}

  return (  
    
    <div className={classes.root}>
        <MyAlert message={MsgAlert} severity="warning" handleClose={onCloseAlert} vertical="top" horizontal="center" open={OpenAlert}/>
        {isLoading ? ( <CircularProgress className="sp-center" /> ) : (<span></span>) }
        {isOpenModListino && <ModListino onUpdate={onLoadData} handleClose={toggleModListino} id={IdModListino}/>}
        <div className="small" style={{width:"98%"}}>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label for="selRicTitolo">Titolo</Label>
                        <Input type="select" className="search" name="selRicTitolo" 
                        id="selRicTitolo" placeholder="" bsSize="sm"
                            value={RicTitolo} onChange={handleRicTitolo}>
                                <option key="" value="">Tutti</option>
                                {GetTitServizi().map((item) => (
                                    <option key={item.titolo_value} value={item.titolo_value}>{item.titolo_name}</option>
                                ))}
                        </Input>
                        <img style={{height:"15pt"}} src={imgSearch} className="input-icon" alt=""/>
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <FormGroup>
                        <Label for="selRicRischio">Rischio</Label>
                        <Input type="select" className="search" name="selRicRischio" 
                        id="selRicRischio" placeholder="" bsSize="sm"
                            value={RicRischio} onChange={handleRicRischio}>
                                <option key="" value="">Tutti</option>
                                <option key="0" value="0">Indifferente</option>
                                <option key="1" value="1">Alto</option>
                                <option key="2" value="2">Medio</option>
                                <option key="3" value="3">Basso</option>
                        </Input>
                        <img style={{height:"15pt"}} src={imgSearch} className="input-icon" alt=""/>
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <FormGroup>
                        <Label for="selRicZona">Zona</Label>
                        <Input type="select" className="search" name="selRicZona" 
                        id="selRicZona" placeholder="" bsSize="sm"
                            value={RicZona} onChange={handleRicZona}>
                                <option key="" value="">Tutti</option>
                                <option key="1" value="1">Centro Nord</option>
                                <option key="2" value="2">centro Sud</option>
                        </Input>
                        <img style={{height:"15pt"}} src={imgSearch} className="input-icon" alt=""/>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label for="selRicDescrizione">Descrizione</Label>
                        <Input type="search" className="search" name="txtRicDescrizione" placeholder=""
                        value={RicDescrizione} onChange={handleRicDescrizione}
                        bsSize="sm"/>
                        <img style={{height:"15pt"}} src={imgSearch} className="input-icon" alt=""/>
                    </FormGroup>
                </Col> 
                <Col md={2}>
                    <FormGroup>
                        <Label>&nbsp;</Label>
                        <Button type="button" className="btn-mbg btn-sm btn-block" disabled={DisableFilter} onClick={onFilter} >Ricerca</Button>
                    </FormGroup>
                </Col>
            </Row>
        </div>
        <div>&nbsp;</div>
        <Paper className={classes.paper}> 
        
        <TableContainer>  
            <Table className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                        aria-label="enhanced table" >  
            <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={rowsPerPage}
                        />  
            <TableBody>  
                {stableSort(data, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                            <TableRow
                                hover
                                tabIndex={-1}
                                key={index}
                                className="rt-tr-group"
                            >
                                <TableCell id={labelId} scope="row">
                                    {
                                    parseFloat(UserRole)===Ruolo_Admin && (
                                    <Avatar className={classes.BtnEdit}  onClick={() => toggleModListino(row.id)}>
                                        <AssignmentIcon />
                                    </Avatar>)
                                    }
                                </TableCell>
                                <TableCell>{row.Titolo}</TableCell>                                
                                <TableCell>{row.Descrizione}</TableCell>
                                <TableCell>{row.DesRischio}</TableCell>
                                <TableCell>{GetTextZona(row.Zona)}</TableCell>
                                <TableCell>{row.Prezzo}</TableCell>
                            </TableRow>
                        );
                    })}
                {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                        <TableCell colSpan={6} />
                    </TableRow>
                )}
            </TableBody>  
            </Table>  
        </TableContainer>  
        <TablePagination  
            rowsPerPageOptions={[50, 75, 100]}  
            component="div"  
            count={data.length}  
            rowsPerPage={rowsPerPage}  
            page={page}  
            onChangePage={handleChangePage}  
            onChangeRowsPerPage={handleChangeRowsPerPage}  
        />  
        </Paper>
        <FormControlLabel
                control={<Switch checked={dense} onChange={handleChangeDense} />}
                label="Riduci"
            />
    </div>  
  );  
} 